import { createRoot } from "react-dom/client";
import App from "./App.tsx";
// Fontes OFFSET : Geist (UI), Geist Mono (technique), Instrument Serif italic (voix éditoriale)
import "@fontsource/geist-sans/400.css";
import "@fontsource/geist-sans/500.css";
import "@fontsource/geist-sans/600.css";
import "@fontsource/geist-mono/400.css";
import "@fontsource/geist-mono/500.css";
import "@fontsource/instrument-serif/400-italic.css";
import "./index.css";

const APP_VERSION = 'v2.9.7';

// Emergency SW Cleanup for Stale Deployments
if (!localStorage.getItem(`sw-nuked-${APP_VERSION}`)) {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.getRegistrations().then((registrations) => {
            let unregCount = 0;
            for (const registration of registrations) {
                console.log('[SW] Unregistering stale SW:', registration);
                registration.unregister();
                unregCount++;
            }
            if (unregCount > 0) {
                console.log('[SW] Nuked stale workers. Reloading...');
                localStorage.setItem(`sw-nuked-${APP_VERSION}`, 'true');
                window.location.reload();
            }
        });
    }
}

console.log(`[Pixel] Booting ${APP_VERSION}`);
createRoot(document.getElementById("root")!).render(<App />);
